import { useQuery } from "react-query";
import { orgUnitApi } from "../../api";

const useFetch = (page: number | undefined, pageSise?: number) => {
  const { isLoading, data, refetch } = useQuery(
    ["fetchOrgUnit", page],
    () => orgUnitApi.fetch({ page, pageSise }),
    {
      enabled: Boolean(page),
    },
  );
  return { isLoading, data, refetch };
};

export default useFetch;
